import React from 'react'
import PropTypes from 'prop-types'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import { withStyles } from '@material-ui/core/styles'
import { Translation } from 'react-i18next'
import { useWatch } from '../../form'
import { NumberFormat } from '../../utils/numberFormat'
import mobileView from '../../utils/mobile.utils'

class SummaryTableComponent extends React.Component {
  render() {
    return <SummaryTable {...this.props} />
  }
}

const styles = (theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },

  tablecell: {
    fontWeight: 'normal',
    fontSize: '13px',
    color: 'black',
    whiteSpace: mobileView ? 'nowrap' : 'normal',
    [theme.breakpoints.down('xs')]: {
      padding: '0 20px'
    },
    [theme.breakpoints.down('400')]: {
      padding: '0 10px'
    }
  },
  tablecell1: {
    fontWeight: 'bold',
    fontSize: '13px',
    color: 'black',
    [theme.breakpoints.down('xs')]: {
      padding: '0 20px'
    },
    [theme.breakpoints.down('400')]: {
      padding: '0 10px'
    }
  },
  button: {
    margin: theme.spacing(1),
    backgroundColor: '#F67131',
    color: 'white',
    fontSize: '12px',
    '&:hover': {
      backgroundColor: '#ff4da6'
    }
  }
})
//console.log('here', store.getState().expense.allowanceCost.full_time_allowance.full_allowance.filter(e => e.country_id === parseInt(getFormValues('newallowance')(store.getState()).country)))
const SummaryTable = ({ allowanceCost, control, classes }) => {
  const watch = useWatch({
    fields: [
      'day_allowance',
      'full_time_allowance',
      'part_time_allowance',
      'meal_allowance',
      'mileage_allowance',
      'distance',
      'vehicle_type',
      'additional_vehicle_cost',
      'forest_trail',
      'heavy_load',
      'working_dog',
      'allowancePassenger',
      'country'
    ],
    control: control
  })

  const { distance, country } = watch

  const fullTimeAllowance = watch.day_allowance ? watch.full_time_allowance : 0
  const partTimeAllowance = watch.day_allowance ? watch.part_time_allowance : 0
  const mealAllowance = watch.day_allowance ? watch.meal_allowance : 0

  const passengerCount = watch.allowancePassenger.length
  const passengerCost = allowanceCost
    ? passengerCount * parseFloat(allowanceCost.passenger_cost.value)
    : 0

  const kmPrice = allowanceCost
    ? calculateKmPrice(allowanceCost, passengerCost, watch)
    : 0

  const countryAllowancePrice = allowanceCost
    ? allowanceCost.full_time_allowance.full_time_allowance.filter(
        (e) => e.country_id === parseInt(country)
      )[0].price
    : 0

  return (
    <Translation>
      {(t) => {
        return (
          <div>
            <div className={classes.root}>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tablecell1}>
                      {t('summaryTable.table')}
                    </TableCell>
                    <TableCell className={classes.tablecell1}>
                      {t('summaryTable.table2')}
                    </TableCell>
                    <TableCell className={classes.tablecell1}>
                      {t('summaryTable.table3')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow style={{ background: '#ebf9fa' }}>
                    <TableCell className={classes.tablecell}>
                      {t('summaryTable.table4')}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.tablecell}
                    >
                      {fullTimeAllowance && !!allowanceCost
                        ? `${fullTimeAllowance} * ${countryAllowancePrice}`
                        : 0}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.tablecell}
                    >
                      <NumberFormat
                        value={fullTimeAllowance * countryAllowancePrice}
                        suffix=" €"
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow style={{ background: 'white' }}>
                    <TableCell className={classes.tablecell}>
                      {t('summaryTable.table5')}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.tablecell}
                    >
                      {partTimeAllowance
                        ? `${partTimeAllowance} * ${allowanceCost.part_time_allowance.value}`
                        : partTimeAllowance}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.tablecell}
                    >
                      <NumberFormat
                        value={
                          partTimeAllowance *
                          (allowanceCost?.part_time_allowance.value ?? 0)
                        }
                        suffix=" €"
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow style={{ background: '#ebf9fa' }}>
                    <TableCell className={classes.tablecell}>
                      {t('summaryTable.table6')}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.tablecell}
                    >
                      {mealAllowance
                        ? `${mealAllowance} * ${allowanceCost.meal_allowance.value}`
                        : mealAllowance}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.tablecell}
                    >
                      <NumberFormat
                        value={
                          mealAllowance *
                          (allowanceCost?.meal_allowance.value ?? 0)
                        }
                        suffix=" €"
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow style={{ background: 'white' }}>
                    <TableCell className={classes.tablecell}>
                      {t('summaryTable.table7')}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.tablecell}
                    >
                      {watch.mileage_allowance && distance
                        ? `${distance} * (${
                            watch.mileage_allowance &&
                            !!watch.vehicle_type &&
                            watch.vehicle_type !== 'default_vehicle_type'
                              ? allowanceCost[watch.vehicle_type]['value']
                              : 0
                          }
                          ${
                            watch.vehicle_type == 'own_car' &&
                            watch.additional_vehicle_cost !=
                              'default_additional_vehicle_cost'
                              ? '+'
                              : ''
                          }
                          ${
                            watch.vehicle_type == 'own_car' &&
                            watch.additional_vehicle_cost !=
                              'default_additional_vehicle_cost'
                              ? allowanceCost[watch.additional_vehicle_cost][
                                  'value'
                                ]
                              : ''
                          }
                          ${
                            watch.vehicle_type == 'own_car' && watch.heavy_load
                              ? '+'
                              : ''
                          } ${
                            watch.vehicle_type === 'own_car' && watch.heavy_load
                              ? allowanceCost.heavy_load.value
                              : ''
                          }
                          ${
                            watch.vehicle_type == 'own_car' &&
                            watch.forest_trail
                              ? '+'
                              : ''
                          } ${
                            watch.vehicle_type === 'own_car' &&
                            watch.forest_trail
                              ? allowanceCost.forest_road.value
                              : ''
                          }
                          ${
                            watch.vehicle_type == 'own_car' && watch.working_dog
                              ? '+'
                              : ''
                          } ${
                            watch.vehicle_type === 'own_car' &&
                            watch.working_dog
                              ? allowanceCost.working_dog.value
                              : ''
                          }
                          ${passengerCost !== 0 ? '+' : ''} ${
                            passengerCost !== 0 ? passengerCount : ''
                          } ${passengerCost !== 0 ? '*' : ''}${
                            passengerCost !== 0
                              ? allowanceCost.passenger_cost.value
                              : ''
                          })`
                        : null}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.tablecell}
                    >
                      <NumberFormat
                        value={(
                          kmPrice * Number.parseFloat(distance) || 0
                        ).toFixed(2)}
                        suffix=" €"
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow style={{ background: '#ebf9fa' }}>
                    <TableCell className={classes.tablecell}>
                      {t('summaryTable.table8')}
                    </TableCell>
                    <TableCell />
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.tablecell}
                    >
                      <NumberFormat
                        value={(
                          fullTimeAllowance * countryAllowancePrice +
                          partTimeAllowance *
                            (allowanceCost?.part_time_allowance.value ?? 0) +
                          mealAllowance *
                            (allowanceCost?.meal_allowance.value ?? 0) +
                          (kmPrice * Number.parseFloat(distance) || 0)
                        ).toFixed(2)}
                        suffix=" €"
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </div>
          </div>
        )
      }}
    </Translation>
  )
}

const calculateKmPrice = (allowanceCost, passengerCost, values) => {
  let kmPrice = 0
  if (!!values && values.mileage_allowance && !!values.vehicle_type) {
    kmPrice = allowanceCost[values.vehicle_type].value + passengerCost
    if (values.vehicle_type === 'own_car') {
      if (!!values.additional_vehicle_cost) {
        kmPrice += allowanceCost[values.additional_vehicle_cost].value
      }
      if (values.forest_trail) {
        kmPrice += allowanceCost.forest_road.value
      }
      if (values.heavy_load) {
        kmPrice += allowanceCost.heavy_load.value
      }
      if (values.working_dog) {
        kmPrice += allowanceCost.working_dog.value
      }
    }
  }
  return kmPrice
}

SummaryTableComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(SummaryTableComponent)
